import { render, staticRenderFns } from "./PDFReport.vue?vue&type=template&id=db6f860e"
import script from "./PDFReport.vue?vue&type=script&lang=ts"
export * from "./PDFReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports